import { Card, Space, Input, Flex, Button, Upload, notification, message } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { NAV_TO_VERSION_LIST } from '@/resources-def/versionSettings-comp';
import { importVersion, exportVersion } from '@/apis/versionSettings';
export const ImportPage = () => {
  const [fileContent, setFileContent] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useResourceNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const handleCancel = () => {
    navigate({ resource: NAV_TO_VERSION_LIST, action: "list" });
  };
  const handleBeforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setFileContent(e.target.result);
      setSelectedFile(file);
    };
    reader.readAsText(file);
    return false; 
  };
  const handleImport = async () => {
    if (!selectedFile) {
      return;
    }
    const formData = new FormData();
    formData.append('fileupload', selectedFile);

    const response = await importVersion(formData);
    if (response.status === "OK") {
      navigate({ resource: NAV_TO_VERSION_LIST, action: "list" });
    } else {
      notification.error({
        description: `Failed to import AIOps Version.${response.message}`,
      });
    }
  };
  return (
    <Card title="Import AIOps Version" 
    style={{ maxWidth: 900, minHeight: 200, marginTop: 0, width: "100%", height: "100%"}}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Flex justify="space-between" align="center"  >
        <span>Version definition:</span>
        <Upload
        beforeUpload={handleBeforeUpload}
        showUploadList={false}
        accept=".txt, .json"
      >
          <Button type="primary">Browse...</Button>
        </Upload>
      </Flex>
        <Input.TextArea
          value={fileContent}
          readOnly
          rows={20}
          style={{width:"100%", resize:"none" }}
        />

        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleImport} disabled={!selectedFile}>
            Import
          </Button>
        </div>
      </Space>
    </Card>
  );
};
export const ExportPage = () => {
  const { state } = useResourceContext();
  const selected = state.selectedResources[0];
  const [fileContent, setFileContent] = useState('');

  const navigate = useResourceNavigate();
  const handleCancel = () => {
    navigate({ resource: NAV_TO_VERSION_LIST, action: "list" });
  };
  const handleExport = async () => {

    const response = await exportVersion(selected.sprint);
    if (response.status === "error") {
      notification.error({
        description: `Failed to export AIOps Version ${selected.sprint}.${response.message||""}`,
      });

    } else {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `AIOpsVersion_${selected.sprint}.json`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      navigate({ resource: NAV_TO_VERSION_LIST, action: "list" });
    }
  };
  return (
    <Card title={`Export AIOps Version`} 
    style={{ maxWidth: 900, minHeight: 200, marginTop: 0, width: "100%", height: "100%"}}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Space direction='horizontal' size={16}>
          <span>AIOps Version</span>
          <Input value={selected?.sprint} disabled={true} />
        </Space>
        <div>Definition</div>
        <Input.TextArea
          value={JSON.stringify(selected||"", null, 2)}
          readOnly
          rows={20}
          style={{width:"100%", resize:"none" }}
        />

        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleExport}>
            Export
          </Button>
        </div>
      </Space>
    </Card>
  );
};
